import styled from 'styled-components';
import colors from 'styles/colors';
import { matchGradientButton, matchOutlineButton, matchSurface } from 'styles/match';

/** Banner CTA do topo do boletim no modo Match (Figma 4:4151). */
export const Container = styled.div`
  ${matchSurface}
  flex-wrap: wrap;

  .banner-label {
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${colors.$dark};
    font-size: 14px;
    font-weight: 600;
  }

  .banner-label img {
    display: block;
    flex-shrink: 0;
    width: 26px;
    height: 24px;
  }

  .banner-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }

  .banner-btn-video {
    ${matchOutlineButton}
  }

  .banner-btn-personalizar {
    ${matchGradientButton}
  }

  @media (max-width: 991px) {
    .banner-actions {
      margin-left: 0;
    }
  }
`;
